import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { get } from 'lodash'
import { AllergyLinkSejourDto } from '../Type/AllergyLinkSejourDto'
import { AllergyLinkSejour } from '../Classes/AllergyLinkSejour'
import { StayApiAdapter } from '../../../dPplanningOp/vue/Adapters/StayApiAdapter'

export class AllergyLinkSejourAPIAdapter implements ApiDataAdapter<AllergyLinkSejour> {
    public createClass(apiData: AllergyLinkSejourDto): AllergyLinkSejour {
        const refLinkedStays = get(apiData, '_refLinkedStays')
        return new AllergyLinkSejour(
            Number(get(apiData, 'id')),
            get(apiData, 'allergy_id'),
            get(apiData, 'sejour_id'),
            get(apiData, 'is_active'),
            refLinkedStays ? new StayApiAdapter().createClass(refLinkedStays) : undefined,
        )
    }
}
